var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMenuBlack(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C_201",
    "data-name": "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C 201",
    transform: "translate(-844 -952)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u041F\\u0440\\u044F\\u043C\\u043E\\u0443\\u0433\\u043E\\u043B\\u044C\\u043D\\u0438\\u043A_233",
    "data-name": "\\u041F\\u0440\\u044F\\u043C\\u043E\\u0443\\u0433\\u043E\\u043B\\u044C\\u043D\\u0438\\u043A 233",
    width: 26,
    height: 26,
    transform: "translate(844 952)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "list-plus",
    transform: "translate(844.5 951.667)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u041F\\u0440\\u044F\\u043C\\u043E\\u0443\\u0433\\u043E\\u043B\\u044C\\u043D\\u0438\\u043A_219",
    "data-name": "\\u041F\\u0440\\u044F\\u043C\\u043E\\u0443\\u0433\\u043E\\u043B\\u044C\\u043D\\u0438\\u043A 219",
    width: 26,
    height: 26,
    transform: "translate(-0.5 0.333)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_15",
    "data-name": "Line 15",
    d: "M10.556-6.386H-7.193A.807.807,0,0,1-8-7.193.807.807,0,0,1-7.193-8H10.556a.807.807,0,0,1,.807.807A.807.807,0,0,1,10.556-6.386Z",
    transform: "translate(11.227 13.664)",
    fill: "#242323"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_16",
    "data-name": "Line 16",
    d: "M10.556-6.386H-7.193A.807.807,0,0,1-8-7.193.807.807,0,0,1-7.193-8H10.556a.807.807,0,0,1,.807.807A.807.807,0,0,1,10.556-6.386Z",
    transform: "translate(11.227 20.118)",
    fill: "#242323"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_17",
    "data-name": "Line 17",
    d: "M3.295-6.386H-7.193A.807.807,0,0,1-8-7.193.807.807,0,0,1-7.193-8H3.295a.807.807,0,0,1,.807.807A.807.807,0,0,1,3.295-6.386Z",
    transform: "translate(11.227 26.572)",
    fill: "#242323"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_18",
    "data-name": "Line 18",
    d: "M-2.353-6.386H-7.193A.807.807,0,0,1-8-7.193.807.807,0,0,1-7.193-8h4.841a.807.807,0,0,1,.807.807A.807.807,0,0,1-2.353-6.386Z",
    transform: "translate(25.749 26.572)",
    fill: "#242323"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_19",
    "data-name": "Line 19",
    d: "M-7.193-1.546A.807.807,0,0,1-8-2.353V-7.193A.807.807,0,0,1-7.193-8a.807.807,0,0,1,.807.807v4.841A.807.807,0,0,1-7.193-1.546Z",
    transform: "translate(28.17 24.152)",
    fill: "#242323"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuBlack);
export default __webpack_public_path__ + "static/media/menu_black.089aeb38f308a4b0de7f73f1e5fa8b2d.svg";
export { ForwardRef as ReactComponent };